module.exports = __webpack_public_path__ + "static/poster-0ad4057c89420b12a51c272250a44442.png";